import type { RequestParams } from '@/shared/api';
import type {
  AgentItemListParams,
  AgentProspectsParams,
  AgentProspectVisitTaskListParams,
} from '../model/types';

export const AGENT_KEYS = {
  all: ['agent'] as const,
  list: (params?: RequestParams) => [...AGENT_KEYS.all, 'list', params] as const,
  detail: (id: number) => [...AGENT_KEYS.all, 'detail', id] as const,
  itemList: (params?: AgentItemListParams) => [...AGENT_KEYS.all, 'item-list', params] as const,
  prospects: (params: AgentProspectsParams) => [...AGENT_KEYS.all, 'prospects', params] as const,
  prospectVisitTasks: (params: AgentProspectVisitTaskListParams) =>
    [...AGENT_KEYS.all, 'prospect-visit-tasks', params] as const,
};
